
// import FormulateInputMixin from '../FormulateInputMixin';
import Loader from '~/components/base/Loader';

export default {
  name: 'FormulateInputButton',
  // mixins: [FormulateInputMixin],
  components: {
    Loader,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  methods: {
    checkAttribute(attribute) {
      const foundAttribute = this.context.attributes[attribute];
      return foundAttribute && (foundAttribute === '' || foundAttribute === true);
    },
  },
};
